import { useState, Fragment, useRef } from 'react';
import {
  DataGrid,
  Column,
  Editing,
  Texts,
  HeaderFilter,
  Search,
} from 'devextreme-react/data-grid';
import notify from 'devextreme/ui/notify';
import {
  CreateAuthorizedDataSource, CreateAuthorizedStore, getAuthorizationTokenAsync
} from '~/helpers/data';
import { ExternalMailSystem } from '~/components/external-mail-system/external-mail-system';
import { EmailClient } from '~/components/email-client/email-client';

export function SchoolDistributionList(props) {
  const [viewEmailClient, setViewEmailClient] = useState(false);
  const [emailFormData, setEmailFormData] = useState();

  const schoolDistributionListGridRef = useRef();

  const schoolDistributionListData = CreateAuthorizedDataSource(
    {
      loadUrl: `${window.env.apiEndpoint}/api/v1/Schools/GetSchoolDistributionLists`,
      deleteUrl: `${window.env.apiEndpoint}/api/v1/Schools/DeleteSchoolDistributionList`,
    },
    {
      load: { schoolId: props.schoolId },
    },
    'Id', false,
  );

  const getInsertSchoolDistributionListStore = (isPrimary) => CreateAuthorizedDataSource(
    {
      insertUrl: `${window.env.apiEndpoint}/api/v1/Schools/PostSchoolDistributionList`,
    },
    {
      insert: { schoolId: props.schoolId, isPrimary: isPrimary },
    },
    'Id', false,
  );

  const onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxDropDownButton',
      options: {
        text: 'Create DL',
        icon: 'add',
        items: [
          { id: 'primary', text: 'Primary' },
          { id: 'all', text: 'ALL' }
        ],
        displayExpr: 'text',
        keyExpr: 'id',

        onItemClick: async (args) => {
          if (args.itemData.id === 'primary') {
            getInsertSchoolDistributionListStore(true).store().insert().then(
              () => {
                schoolDistributionListGridRef.current.instance().refresh();
              },
              (e) => {
                notify({ message: e.message, shading: true }, 'error');
              }
            )
          }

          if (args.itemData.id === 'all') {
            getInsertSchoolDistributionListStore(false).store().insert().then(
              () => {
                schoolDistributionListGridRef.current.instance().refresh();
              },
              (e) => {
                notify({ message: e.message, shading: true }, 'error');
              }
            )
          }
        }
      }
    });
  };

  return (
    <Fragment>
      <DataGrid
        dataSource={schoolDistributionListData}
        key="Id"
        height='100%'
        onToolbarPreparing={onToolbarPreparing}
        ref={schoolDistributionListGridRef}
      >
        <HeaderFilter
          visible={false}
        >
          <Search enabled={true} />
        </HeaderFilter>
        <Editing
          mode="row"
          allowAdding={false}
          allowDeleting
          allowUpdating={false}
        >
          <Texts
            confirmDeleteMessage={"Are you sure to delete this school distribution list."} />
        </Editing>
        <Column
          dataField="Name"
          dataType="text"
          caption="Name"
          allowEditing={false} />
        <Column
          dataField="StatusMessage"
          cellRender={
            (data) => {
              const row = data.data;
              return <ExternalMailSystem statusMessage={row.StatusMessage} hasError={row.HasError} entityId={row.Id} entityType="SchoolDistributionList" />
            }
          }
        />
        <Column
          type="buttons"
          width={110}
          buttons={[
            {
              name: "delete",
              hint: "Delete school Distribution List",
              icon: 'trash',
            },
            {
              name: "email",
              hint: "Send Email to Distribution List",
              icon: 'email',
              onClick: async (e) => {
                const token = await getAuthorizationTokenAsync();

                const defaultFromEmailDS = CreateAuthorizedStore({ loadUrl: `${window.env.apiEndpoint}/api/v1/DistributionList/GetDefaultFromEmail` }, null, 'Value');
                defaultFromEmailDS.load().then(
                  (data) => {
                    setViewEmailClient(true);
                    setEmailFormData({ email: token.account.username, name: data[0].fromName, to: e.row.data.Name });
                  },
                  (error) => {
                    notify({ message: error.message, shading: true }, 'error');
                  }
                );
              },
            },
          ]}
        />
      </DataGrid>
      <EmailClient visible={viewEmailClient} formData={emailFormData} setViewEmailClient={setViewEmailClient} />
    </Fragment>
  );
}